import { AttributesOptionObjDto } from './dto/attributes-option-dto';
import { CreateSpecificationAttributeDto } from './dto/create-specification-attribute-dto';
import ApiService from "../../utils/base-api/api-service";
import { AttributeListByCategoryObjDto } from "./dto/attribute-list-by-category-dto";
import { SpecificationAttributesObjDto } from "./dto/specification-attributes-dto";
import { SpecificationAttributesParamsDto } from "./dto/specification-attributes-params-dto";
import { SpecificationAttributeDetailsDto } from './dto/specification-attribute-details-dto';
import { CreateOptionBySpecificationAttributeDto } from './dto/create-option-dto';

class SpecificationAttributeService extends ApiService {
    constructor() {
        super({
            baseURL: '/AdminSpecificationAttribute',
        });
    }

    getSpecificationAttributes(input: SpecificationAttributesParamsDto): Promise<SpecificationAttributesObjDto> {
        return this.post('/List',{}, {params: input});
    }

    create(input: CreateSpecificationAttributeDto) {
        return this.post('/Create', input);
    }
    
    edit(input: CreateSpecificationAttributeDto) {
        return this.post('/Edit', input);
    }
    
    deleteSpecificationAttribute(input: string) {
        return this.post(`/Delete?id=${input}`);
    }

    getSpecificationAttributeByID(input: string): Promise<SpecificationAttributeDetailsDto> {
        return this.get('/GetSpecificationAttributeByID', {params: {id: input}});
    }

    getOptionsBySpecificationAttributeId(input: string): Promise<AttributesOptionObjDto> {
        return this.post(`/OptionList?specificationAttributeId=${input}`);
    }

    createOptionBySpecificationAttribute(input: CreateOptionBySpecificationAttributeDto) {
        return this.post('/OptionCreatePopup', input);
    }

    editOptionBySpecificationAttribute(input: CreateOptionBySpecificationAttributeDto) {
        return this.post('/OptionEditPopup', input);
    }

    deleteOption(input: string) {
        return this.post(`/OptionDelete?id=${input}`);
    }

    getAttributeListByCategory(input: any): Promise<AttributeListByCategoryObjDto> {
        return this.post('/ListByCategory', input);
    }
}

export const specificationAttributeService = new SpecificationAttributeService();